import { idGenerator } from "Util/uniqueIdGenerator";

const GROUP_SUBFIELD_ID_GENERATOR = new idGenerator();

export const ClientCreatableType = {
    DataField: 0,
    DataFieldGroup: 1,
    Attachment: 2,
    FormElement: 3
};

export function getNewDataField(name, placeholderId, groupId, fieldSchema) {
    return {
        Name: name,
        PublicId: placeholderId,
        TypeId: fieldSchema.DataFieldType,
        EncodingTypeId: fieldSchema.EncodingType || null,
        DataFieldGroupId: groupId,
        ListId: null,
        IsNew: true,
        IsMultiInstance: fieldSchema.IsMultiInstance
    };
}

export function getNewDataFieldGroup(name, placeholderId, groupSchema) {
    return {
        Name: name,
        PublicId: placeholderId,
        TypeId: groupSchema.GroupType,
        IsNew: true,
        Attributes: {},
        _dataFields: groupSchema.ChildFields.map((childField) => {
            const childName = name + childField.Suffix;
            const childPlaceholderId = GROUP_SUBFIELD_ID_GENERATOR.getNextId(placeholderId);
            return getNewDataField(childName, childPlaceholderId, placeholderId, childField.Schema);
        }),
        _dataFieldKeys: groupSchema.ChildFields.map((childField) => childField.Suffix.trim())
    };
}

export function getNewAttachment(name, placeholderId, initialAllowedExtensions = []) {
    return {
        AllowedExtensions: initialAllowedExtensions,
        Name: name,
        PublicId: placeholderId,
        IsNew: true
    };
}

export function getNewFormElement(
    className,
    dataFieldId,
    dataFieldGroupId,
    attachmentId,
    placeholderId,
    defaultProperties = {},
    groupDataFields = null
) {
    // properties defined explicitly so they are observable to vue
    return {
        AttachmentId: attachmentId,
        AuxiliaryModel: null,
        ClassName: className,
        DataFieldGroupId: dataFieldGroupId,
        DataFieldId: dataFieldId,
        DependencyDefinitions: [],
        ESignatureConstant: null,
        EnvelopeId: null,
        GeneratedDocumentTemplateId: null,
        GroupDataFields: groupDataFields ? { ...groupDataFields } : null,
        IsNew: true,
        Position: 0,
        Properties: { ...defaultProperties },
        PublicId: placeholderId,
        Signatories: null,
        VisibilityRule: null
    };
}

export function getNewListItem(label, name, order, placeholderId) {
    return {
        Label: label,
        Name: name,
        Order: order,
        PlaceholderId: placeholderId,
        IsNew: true
    };
}

/**
 * Produces a key for the provided list view item.
 * @param {Object} item Client representation of a ListViewItem.
 * @returns A unique key for the list item, acommodating for new list items without an assigned ListItemDefinitionId.
 */
export function getListItemKey(item) {
    return item.IsNew ? item.PlaceholderId.toString() : item.ListItemDefinitionId.toString();
}
